import { memo, ReactNode, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { ProblemDetails } from "../../api";
import { useAppDispatch, useAppSelector } from "../../store";
import { getByReferralCodeAsync } from "../../store/clientQuestionnaires";
import { Body } from "../client/GridLayout";
import QuestionnaireScreen from "../client/QuestionnaireScreen";
import LoadingScreen from "../containers/LoadingScreen";
import ScaffoldAppScreen from "../containers/ScaffoldAppScreen";
import { SubtitleText, TitleText } from "../controls/helpers";

const ScreenWrapper = memo(({ children, errors, isClient, onSubmit }: { children: ReactNode; errors: ProblemDetails | undefined; isClient: boolean; onSubmit: () => void }) => {
  return isClient ? (
    <QuestionnaireScreen hidePrev>
      <Body isNarrowView>{children}</Body>
    </QuestionnaireScreen>
  ) : (
    <ScaffoldAppScreen errorMessage={errors ? "Something went wrong, please try again." : undefined} header="Welcome" hideNext={!!errors} isNarrowView initialValues={{}} onSubmit={onSubmit} route="">
      {children}
    </ScaffoldAppScreen>
  );
});

const Welcome = ({ history, isClient = false, match }: RouteComponentProps & { isClient?: boolean }) => {
  const dispatch = useAppDispatch();
  const { referralCode } = match.params as { referralCode: string };
  const { adviserName, clientFirstName, errors, isLoading } = useAppSelector((state) => state.clientQuestionnaires);

  useEffect(() => {
    !isClient && dispatch(getByReferralCodeAsync(referralCode));
  }, [dispatch, isClient, referralCode]);

  if (isLoading || (!adviserName && !errors)) {
    return <LoadingScreen />;
  }

  return (
    <ScreenWrapper errors={errors} isClient={isClient} onSubmit={() => history.push(`/invite/${referralCode}/information`)}>
      <TitleText>{isClient && <>Hi {clientFirstName}. </>}Take a few minutes to sort your retirement savings.</TitleText>
      <SubtitleText>
        This tool helps you maximise your savings by:
        <ul>
          <li>Giving you information about the KiwiSaver regime, savings rates, and NZ Funds' savings solutions.</li>
          <li>Enabling you to receive advice on how to achieve your long-term savings goals.</li>
          <li>Providing a simple sign-up process to implement any advice recommendations you receive if you choose to invest in an NZ Funds’ savings solution.</li>
        </ul>
        <br />
        By clicking start you agree to{" "}
        <a href="https://www.nzfunds.co.nz/emailarticles/documents/myNZFunds/NZ_Funds_Digital_Platform_Terms_and_conditions.pdf" target="_blank">
          NZ Funds' Terms and Conditions
        </a>
        . NZ Funds will share the information you provide via this tool with the Financial Advice Provider who provided you the link to this tool.
      </SubtitleText>
    </ScreenWrapper>
  );
};

export default Welcome;
